<template>
  <div id="person">
    <div class="title">询问管理</div>

    <div class="container">
      <div>
        <div class="linemaintype">
        <span class="lefttext">用户名：</span>
        <span class="righttext">{{roleData.user.username}}</span>
      </div>
      <div class="linemaintype">
        <span class="lefttext">账户类型：</span>
        <span class="righttext">{{roleData.roleList[0].roleName}}</span>
      </div>
      <div class="linemaintype">
        <span class="lefttext">所属部门：</span>
        <span class="righttext">{{roleData.deptList[0].deptName}}</span>
      </div>
      <div class="linemaintype">
        <span class="lefttext">手机号码：</span>
        <span class="righttext">{{roleData.user.phone}}</span>
      </div>
      <div class="linemaintype">
        <span class="lefttext">监督证号：</span>
        <span class="righttext">{{roleData.user.certNo}}</span>
      </div>
      <div class="linemaintype">
        <span class="lefttext">真实姓名：</span>
        <span class="righttext">{{roleData.user.nickname}}</span>
      </div>
      <div class="linemaintype">
        <span class="lefttext">用户手册：</span>
        <span class="righttext">
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            style="display: inline-block; color: #10beb8;"
          >
            <span style="display: inline-block; color: #10beb8;">拱墅区卫监笔录系统使用手册</span>
          </a>
        </span>
      </div>
      </div>
      <div class="psd">
        <el-button type="primary" @click="changepsd">修改密码</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="psdshow" title='修改密码' width="20%">
      <div style="margin: 10px 0;">旧密码</div>
      <el-input placeholder="请输入旧密码" v-model="oldpsd" type="text"></el-input>
      <div style="margin: 10px 0;">新密码</div>
      <el-input placeholder="请输入新密码" v-model="newpsd" type="text"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="psdshow = false">取 消</el-button>
        <el-button type="primary" @click="changepsdreq">确 定</el-button>
      </span>
    </el-dialog>
    <!-- </el-card> -->
  </div>
</template>
<script>
import { messages } from '@/util/resetMessage.js';
import { currentUser,changepassword } from "../axios/api.js";

export default {
  data() {
    return {
      activeName: "first",
      roleData: [],
      roleoption: {},
      psdshow:false,
      newpsd:null,
      oldpsd:null
    };
  },
  methods: {
    changepsdreq(){
      var reg = new RegExp(/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{9,}/, 'g')
      const regs = new RegExp(/\s/g)
      if(!this.oldpsd){
        messages.error('请输入旧密码')
      }else if (regs.test(this.newpsd) || !reg.test(this.newpsd)) {
        messages.error('请输入9位以上的大小写字母、数字，以及特殊字符混合表达式,且不能输入空格')
      } else {
        changepassword([this.roleData.user.username,this.oldpsd,this.newpsd]).then(res=>{
          if (res.code===200) {
            messages.success('修改成功')
            this.newpsd=null
            this.oldpsd=null
            this.psdshow=false
          }
        })
      }
    },
    changepsd(){
      this.psdshow=true
    },
    //获取当前角色
    getnowrole() {
      currentUser([]).then(res => {
        console.log(res.data);
        this.roleData = res.data;
      });
    }
  },
  created() {
    // 加载表格数据
    this.getnowrole();
    // this.getrole();
  }
};
</script>
<style scoped>
.titlebottom {
  border-bottom: 3px solid #10beb8;
  padding-bottom: 3px;
  display: inline-block;
}

#person .lefttext {
  display: inline-block;
  width: 200px;
  text-align: right;
}

#person .righttext {
  color: #999999;
}

.linemaintype {
  margin-bottom: 30px;
  margin-top: 30px;
}

.linemains {
  text-align: left;
  margin-bottom: 0;
  padding: 20px;
  background: white;
  box-shadow: 0px 0px 8px 0px rgba(202, 202, 202, 0.3);
}
::v-deep .el-dialog__title {
  /* background-color: #fff; */
  color: #fff;
}
.headermaintitle {
  height: 40px;
  display: flex;
  align-items: center;
  margin-top: 10px;
  box-sizing: border-box;
  padding-bottom: 10px;
}
.psd{
  width: 200px;
  text-align: left;
  margin-top: 30px;
}
.container{
  display: flex;
  justify-content: space-between;
}
</style>
